import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  icon: {
    color: 'rgba(0, 0, 0, 0.56)',
    position: 'absolute',
    top: 36,
    width: 20,
    height: 20,
    left: 0,
  },
  textField: {
    '& > p': {
      marginBottom: -20,
    }
  },
});

class IcoTextField extends Component {
  render() {
    const { icon: SvgIcon, classes, ...rest } = this.props;
    return (
        <div
          style={{ position: 'relative', textAlign: 'left' }}>
          <SvgIcon
            className={classes.icon}/>
          <TextField
            className={classes.textField}
            style={{ marginLeft: 32, width: 'calc(100% - 32px)' }}
            fullWidth
            {...rest}
            classes={null}
            error={!!this.props.error}></TextField>
        </div>
    );
  }
}

export default withStyles(styles)(IcoTextField)



// WEBPACK FOOTER //
// ./src/components/common/IcoTextField/index.js